import TouchIdBaseScreen from './touch_id_screen_base';
import {TOUCH_ID} from '../touch_id_component_consts';
import DOM from '../../../../../utils/dom';


class TouchIdAutoInitScreen extends TouchIdBaseScreen {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'TouchIdAutoInitScreen';
    _selector = 'cgp-touch-id-screen-init';

    _checkboxToggle = null;
    _butNext = null;

    init(params) {
         super.init(params);
         this._setHtml(TOUCH_ID.INIT_VIEW);
    }

    show() {
        super.show();

        DOM.addClass(this.getEl().getElementsByClassName('cgp-touch-id-content')[0], this._selector);

        return this;
    }

    /**
     * Subscribe for change of toggle.
     *
     * @public
     */
    onComponentOpened() {
        this.onInitScreenShow();

        DOM.onDOMElementEvent(this.getEl().querySelector(TOUCH_ID.ACTIVATION_BUTTON_CONFIRM), 'click', () => {

            this._parent.getTokenFromSrv();

            this._parent.serviceFactory.analyticsService().sendOrbitUserFlowEvent(
                {
                    category:'Client_TouchID',
                    action: 'Activation'
                });

            this.close();
        });

        return this;
    }

    onClosedByClicked() {
        super.onClosedByClicked();
    }
}
export default TouchIdAutoInitScreen;
